import { render, staticRenderFns } from "./FontDesigner.vue?vue&type=template&id=2d2334ce"
import script from "./FontDesigner.vue?vue&type=script&lang=js"
export * from "./FontDesigner.vue?vue&type=script&lang=js"
import style0 from "./FontDesigner.vue?vue&type=style&index=0&id=2d2334ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports